export const SET_CALENDER_RANGE = "SET_CALENDER_RANGE"
export const SET_ADULTS = "SET_ADULTS"
export const SET_ROOMS = "SET_ROOMS"
export const SET_CHILDREN = "SET_CHILDREN"
export const SET_SELECTED_HOTEL_DATA = "SET_SELECTED_HOTEL_DATA"
export const SET_CLICKED_BOOK_NOW = "SET_CLICKED_BOOK_NOW"
export const DATA_FOR_GET_HOTEL_BY_ID = "DATA_FOR_GET_HOTEL_BY_ID" 